export const dateSub = (testDate, baseDate) => {
    const msInADay = 1000 * 60*60*24;
    let difference = (testDate - baseDate)/msInADay;
    return Math.floor(difference);
  } 